import script from "./TableHeaderSalesOfferAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./TableHeaderSalesOfferAdd.vue?vue&type=script&setup=true&lang=js"

import "./TableHeaderSalesOfferAdd.vue?vue&type=style&index=0&id=6a9ee792&lang=css"

const __exports__ = script;

export default __exports__